import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51f110d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quota-usage" }
const _hoisted_2 = { class: "quota-usage-header" }
const _hoisted_3 = { class: "quota-usage-label" }
const _hoisted_4 = {
  key: 0,
  class: "quota-usage-progress"
}
const _hoisted_5 = {
  key: 0,
  class: "quota-usage-info"
}
const _hoisted_6 = {
  key: 1,
  class: "quota-usage-info"
}

import { computed } from 'vue'

import SelectGasProvider from './GasProvider.vue'
import useNumbers from '@/popup/compositions/useNumbers'
import Progress from '@/popup/components/shared/Progress.vue'
import { hasRelayerGasQuota } from '@/shared/relayer'
import { Error } from '@/popup/components/shared/Form/Form'
import { FrontendProfile } from '@/shared/models/Profile'
import { RelayServiceDBSchema } from '@/shared/Database/UPSettings/models'
import { GasProvider } from '@/shared/models/GasProvider'
import { d } from '@/popup/lib/i18n'
import { QuotaDTO } from '@/business-logic/relay-service'

type Props = {
  estimateGasLimit?: string
  relayerQuota?: QuotaDTO
  currentProfile: FrontendProfile
  allRelayers: RelayServiceDBSchema[]
  transactionFee: number
  balance: number
  selectedGasProvider: GasProvider
}

type Emits = {
  (event: 'on-gas-provider-change', value: GasProvider): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QuotaUsage',
  props: {
    estimateGasLimit: {},
    relayerQuota: {},
    currentProfile: {},
    allRelayers: {},
    transactionFee: {},
    balance: {},
    selectedGasProvider: {}
  },
  emits: ["on-gas-provider-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const { formatNumber } = useNumbers()

const relayerGasUsed = computed(() => {
  if (!props.relayerQuota || !props.relayerQuota?.totalQuota) {
    return 0
  }

  return props.relayerQuota.totalQuota - props.relayerQuota.quotaRemaining
})

const relayerGasUsedPercentage = computed(() => {
  if (!props.relayerQuota?.totalQuota) {
    return 0
  }
  return props.relayerQuota?.totalQuota
    ? Number(
        ((relayerGasUsed.value / props.relayerQuota.totalQuota) * 100).toFixed(
          4
        )
      )
    : 0
})

const transactionGasPercentage = computed(() => {
  if (
    !props.estimateGasLimit ||
    !props.relayerQuota ||
    !props.relayerQuota?.totalQuota
  ) {
    return 0
  }

  return Number(
    (
      (Number(props.estimateGasLimit) / props.relayerQuota.totalQuota) *
      100
    ).toFixed(4)
  )
})

const barOverHalf = computed(
  () => relayerGasUsedPercentage.value + transactionGasPercentage.value > 50
)

const isOverBalance = computed(
  () => !hasRelayerGasQuota(props.relayerQuota, props.estimateGasLimit)
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('confirmation.quota_usage.header')), 1 /* TEXT */),
      _createVNode(SelectGasProvider, {
        "current-profile": _ctx.currentProfile,
        "all-relayers": _ctx.allRelayers,
        "transaction-fee": _ctx.transactionFee,
        balance: _ctx.balance,
        "selected-gas-provider": _ctx.selectedGasProvider,
        onOnGasProviderChange: _cache[0] || (_cache[0] = 
          value => emits('on-gas-provider-change', value)
        )
      }, null, 8 /* PROPS */, ["current-profile", "all-relayers", "transaction-fee", "balance", "selected-gas-provider"])
    ]),
    (_ctx.relayerQuota)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(Progress, {
            data: [
          {
            value: relayerGasUsedPercentage.value,
            color: 'var(--neutral-90)',
            title: _ctx.$t('confirmation.quota_usage.relayer_gas_used', {
              relayerGasUsed: _unref(formatNumber)(relayerGasUsed.value),
            }),
          },
          {
            value: transactionGasPercentage.value,
            color: 'var(--neutral-60)',
            title: _ctx.$t('confirmation.quota_usage.estimate_gas_limit', {
              estimateGasLimit: _unref(formatNumber)(_ctx.estimateGasLimit),
            }),
          },
        ],
            label: 
          _ctx.$t('confirmation.key_usage.progress_label', {
            estimatedGas: _unref(formatNumber)(_ctx.estimateGasLimit, 'compact'),
            balance: _unref(formatNumber)(_ctx.relayerQuota.quotaRemaining, 'compact'),
          })
        ,
            unit: _ctx.$t('confirmation.quota_usage.gas'),
            "label-position": barOverHalf.value ? 'left' : 'right',
            class: _normalizeClass({
          error: isOverBalance.value,
        })
          }, null, 8 /* PROPS */, ["data", "label", "unit", "label-position", "class"]),
          (!isOverBalance.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.relayerQuota.resetDate &&
          _ctx.relayerQuota.totalQuota &&
          _unref(d)(_ctx.relayerQuota.resetDate)
            ? _ctx.$t('confirmation.quota_usage.progress_info', {
                total: _unref(formatNumber)(_ctx.relayerQuota.totalQuota, 'compact'),
                date: _unref(d)(_ctx.relayerQuota.resetDate * 1000),
              })
            : _ctx.relayerQuota.totalQuota
            ? _ctx.$t('confirmation.quota_usage.progress_info_without_reset', {
                total: _unref(formatNumber)(_ctx.relayerQuota.totalQuota, 'compact'),
              })
            : _ctx.$t(
                'confirmation.quota_usage.progress_info_without_reset_and_total',
                {
                  quota: _unref(formatNumber)(_ctx.relayerQuota.quotaRemaining, 'compact'),
                }
              )), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_unref(Error), {
                  error: 
            _ctx.relayerQuota.resetDate && _unref(d)(_ctx.relayerQuota.resetDate)
              ? _ctx.$t('confirmation.quota_usage.progress_error', {
                  date: _unref(d)(_ctx.relayerQuota.resetDate * 1000),
                })
              : _ctx.$t('confirmation.quota_usage.progress_error_without_date')
          
                }, null, 8 /* PROPS */, ["error"])
              ]))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})